module.exports = __webpack_public_path__ + "media/images/icon_support-56404c4141f0a464fc60ed168a0375e2.svg";